import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import Group from "@mapmycustomers/shared/types/entity/Group";

import EntityTag from "@app/component/EntityTag";
import useRowHeightUpdater from "@app/component/grid/util/hooks/useRowHeightUpdater";

import styles from "./GroupsCellRenderer.module.scss";

const GroupsCellRenderer: React.FC<ICellRendererParams> = ({ api, node, value }) => {
  useRowHeightUpdater(node, api);

  if (!value || !value.length) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  return (
    <div className={styles.container}>
      {(value as Group[])
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
        .map((group) => (
          <EntityTag className={styles.tag} entity={group} key={group.id} />
        ))}
    </div>
  );
};

export default GroupsCellRenderer;
